import { defineMessages } from "react-intl";

export const messages = defineMessages({
    orgSelectorDropdownSelectedCloudOrg: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org",
        defaultMessage: "Cloud org: {orgName}",
        description:
            "Selected org on org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownNoOrgForOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org-is-no-org",
        defaultMessage: "Tickets from Other Cloud Orgs",
        description:
            "Message for MOVE tickets from cloud orgs that the customer is NOT org admin of, in the org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownLoadingOrgs: {
        id: "fastshift.dashboard.welcome-banner.org-selector.orgs-loading",
        defaultMessage: "Loading orgs...",
        description:
            "Message displayed on org selector while orgs are still loading"
    },
    orgSelectorDropdownNotOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.not-org-admin",
        defaultMessage:
            "Welcome to the FastShift Portal. You can track migration progress for the products you're an admin of here.",
        description:
            "Message displayed instead of the dropdown when the user is not an org admin"
    }
});
